import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '../../../web/src/environments/environment';
import { DTGAuthService } from 'ditagis-auth';

export interface ConfigApp {
  title: string;
  mobileLink: {
    android: string,
    ios: string
  },
  map: {
    legend: {
      quyHoachChiTiet,
      quyHoachPhanKhu,
      taiNguyenMoiTruong
    }
    defaultLstCoords: Array<{ toaDoX: number, toaDoY: number }>,
    layers: {
      thongTinQuyHoach: __esri.TileLayerProperties,
      thuaDat: __esri.MapImageLayerProperties,
      taiNguyenMoiTruong?: __esri.TileLayerProperties
    },
    notes?: {
      ketQua?: string
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private configApp: ConfigApp;

  constructor(
    private authService: DTGAuthService
  ) {
  }

  getApp(): Observable<ConfigApp> {
    if (this.configApp) {
      return of(this.configApp);
    }
    return this.authService.getAppInfo({
      appId: environment.appId.app,
      isGuest: true
    })
      .pipe(
        map(m => m.config as ConfigApp),
        tap({
          next: config => {
            this.configApp = config;
          }
        })
      );
  }

  getRoot(): Observable<any> {
    return this.authService.getAppInfo({
      appId: environment.appId.root,
      isGuest: true
    })
      .pipe(
        map(m => m.config)
      );
  }
}
